import styled from "@emotion/styled";
import {
    colorVariables,
    fontSizes,
    fontWeights,
    gutterSizes,
    lineHeights,
} from "@gumtree/ui-library/src/base/theme";

export const StyledShowMoreContainer = styled.span`
    color: ${colorVariables.textLink};
    cursor: pointer;
    font-weight: ${fontWeights.lightBold};
    font-size: ${fontSizes.base};
    line-height: ${lineHeights.base};
    margin-top: ${gutterSizes.medium10};

    .chevron {
        margin-left: ${gutterSizes.base};
    }
`;
